<div class="comp-people photos">
    <img class="w-100 h-100 person" [src]="apiAsset + dataPeople?.picture" alt="">
    <div class="overlay-title text-center">
        <h6 class="position mb-2">{{ dataPeople?.position }}</h6>
        <p class="name">{{ dataPeople?.fullname }}</p>
    </div>
</div>